import { AlertTriangle } from 'lucide-react'

import { m } from '@/lib/paraglide/messages'
import { twJoin } from '@/lib/utils'

interface Props {
    /** Số dòng KiotViet chưa nối của đơn. */
    count: number
    /** Người dùng có quyền nối (products.update). */
    canLink: boolean
}

/** Cảnh báo đầu bảng hàng hoá khi đơn KiotViet còn dòng chưa nối (M-145). */
export function KiotVietUnlinkedNotice({ count, canLink }: Props) {
    if (count <= 0) return null
    return (
        <div
            role="status"
            className={twJoin(
                'mb-3 flex items-start gap-2 rounded-md border p-3 text-sm',
                'border-amber-300 bg-amber-50 text-amber-900',
                'dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200',
            )}
        >
            <AlertTriangle className="mt-0.5 size-4 shrink-0" aria-hidden />
            <span>
                {canLink
                    ? m.kiotviet_unlinked_notice({ count: String(count) })
                    : m.kiotviet_unlinked_no_permission()}
            </span>
        </div>
    )
}
